import React from "react";
import ReactDOM from "react-dom";

import EventSearchOverview from "./EventSearchOverview";

(() => {
  const eventSearchOverviewContainer = document.querySelector(
    "[data-events-search-container]"
  );

  if (eventSearchOverviewContainer) {
    ReactDOM.render(
      <EventSearchOverview />, // eslint-disable-line
      eventSearchOverviewContainer
    );
  }
})();
